import styled from '@emotion/styled';
import Comps from '@owenscorning/react-library';
import React from 'react';
import { connect } from 'react-redux';

import TextInput from '../../shared/TextInput/index.jsx';
import AddressVerificationModal from '../../shared/address-verification-modal';
import ErrorModal from '../../shared/error-modal';
import { BackArrow } from '../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData, verifyAddress } from '../redux/actions';
import { InputWrapper } from '../styled-components';

const { AddressGroup } = Comps.Connect.FormElements;
const { Spinner } = Comps.Connect;

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
  }
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const mapStateToProps = state => ({
  formData: state.formData,
  isFetching: state.isFetching,
});

const Step5 = ({ decrementStep, formData, setFormData, verifyAddress, isFetching }) => {
  const validatePhone = formData.homeownerPhone && formData.homeownerPhone.length === 12;
  let validated =
    formData.propertyAddress.street &&
    formData.propertyAddress.city &&
    formData.propertyAddress.zip &&
    formData.propertyAddress.state;

  if (formData.registrantType === 'homeowner') {
    validated = validated && validatePhone;
  }

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 5 - where was the roof installed"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>
          {formData.registrantType === 'homeowner'
            ? 'What is your name?'
            : 'What is the Homeowner’s Name & Contact information?'}
        </BackText>
      </BackWrapper>
      <p>Awesome! Can you tell us...</p>
      <Header>Where was the roof installed?</Header>
      <AddressGroup
        value={formData.propertyAddress}
        onChange={address => {
          setFormData({ propertyAddress: address });
        }}
        suggestionEndpoint={`${MDMS_URL}/api/v1/smarty/suggestions`}
        showComplaints={false}
        country="US"
      />
      {formData.registrantType === 'homeowner' && (
        <InputWrapper>
          <TextInput
            fieldKey="homeownerPhone"
            value={formData.homeownerPhone || ''}
            htmlAttributes={{
              placeholder: 'Enter phone number here',
              pattern: '[0-9 -]*',
              isphoneinput: 'true',
              maxLength: 12,
            }}
          />
        </InputWrapper>
      )}
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 5 - where was the roof installed"
        onClick={verifyAddress}
        disabled={!validated}
      >
        {isFetching ? (
          <>
            <Spinner /> Loading
          </>
        ) : (
          'Next'
        )}
      </NextButton>
      <ErrorModal />
      <AddressVerificationModal />
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
  verifyAddress: () => dispatch(verifyAddress()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step5);
